<template>
  <!-- TODO: Set z-index for right column parent if refactor this file, please :) - https://ahaslides.atlassian.net/browse/AHA-9036 -->
  <div class="multiple-choice-type">
    <QuizInfo v-if="isShowQuizInfo" style="margin-bottom: 20px" />
    <SlideTitleSettings v-if="isSlideTitleSettingVisible" :keyUndoRedo="key" />
    <AdditionalFields v-if="isTypeHasAdditionalFields" />
    <SubheadingInput v-if="isContentSlide" :key="'text_slide' + key" @updateSlide="updateSlide" />
    <WordCloudInput
      v-if="slideActive.type == 'wordCloud'"
      @updateSettingSlide="updateSettingSlide"
    />

    <!-- Slide options -->
    <SlideOptionsInputV2
      :isSortingSlideOptions="isSortingSlideOptions"
      :optionLabel="optionLabel"
      :optionTooltip="optionTooltip"
      :keyInput="key"
      @sortOption="sortOption"
      @updateSettingSlide="updateSettingSlide"
      @updateTitleOption="updateTitleOption"
      @addOption="addOption"
      @deleteOption="deleteOption"
      @updateOption="_updateOption"
      @backupAddOptionFromTab="backupAddOptionFromTab"
    />

    <!-- End of slide options -->
    <Settings v-if="slideActive.type === 'pickAnswer'" />
    <ScaleQuestionContentTab v-if="slideActive.type == 'scale'" @updateSlide="updateSettingSlide" />

    <TimeLimitConfig />

    <OtherSettings v-if="otherSettingsVisible" />
    <!-- Q&A -->
    <RightColumnQnASettings v-if="slideActive.type === 'question'" />

    <ModalDeleteScalesStatement
      v-if="isModalDeleteScalesStatementVisible"
      :modalContent="contentModalDeleteScalesStatement"
      :deleteSlideOptionIndex="deleteSlideOptionIndex"
      @deleteOption="handleDeleteScalesStatement"
      @hide="handleCloseModalDeleteScalesStatement()"
    />
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'

import Config from '@/config'
import AdditionalFields from '@/components/presentations/AdditionalFields'
import Utils from '@/util'
import Socket from '@/socket'
import EventBus from '@/eventBus'
import TimeLimitConfig from '@/components/presentations/types/TimeLimitConfig.vue'
import ScaleQuestionContentTab from '@/components/presentations/types/ScaleQuestionContentTab.vue'
import Settings from '@/components-v2/presentation-editor/side-right/Settings.vue'
import SubheadingInput from '@/components-v2/presentation-editor/side-right/SubheadingInput.vue'
import WordCloudInput from '@/components-v2/presentation-editor/side-right/WordCloudInput.vue'
import SlideOptionsInputV2 from '@/components-v2/presentation-editor/side-right/SlideOptionsInputV2.vue'
import RightColumnQnASettings from '@/components-v2/presentation-editor/side-right/RightColumnQnASettings.vue'
import OtherSettings from '@/components-v2/presentation-editor/side-right/OtherSettings.vue'
import SlideTitleSettings from '@/components-v2/presentation-editor/side-right/SlideTitleSettings.vue'
import QuizInfo from '@/components/presentations/QuizInfo.vue'
import PresentationUtils from '@/utils/presentation'

// modals
import ModalDeleteScalesStatement from '@/components-v2/modals/DeleteScalesStatement.vue'

// api
import SlideOptionApi from '@/api/slideOption'
import gaCategories from '@/constant/gaCategories'
import constants from '@/constant'
import SlideApi from '@/api/slide'

// services
import cookie from '@/services/cookie'
import UndoRedoMixin from '@/mixins/undo-redo/UndoRedoMixin'
import UpdateTitleSlideMixin from '@/mixins/undo-redo/UpdateTitleSlideMixin'

export default {
  name: 'MultipleChoiceQuestion',
  components: {
    AdditionalFields,
    TimeLimitConfig,
    ScaleQuestionContentTab,
    Settings,
    ModalDeleteScalesStatement,
    SubheadingInput,
    WordCloudInput,
    SlideOptionsInputV2,
    RightColumnQnASettings,
    OtherSettings,
    SlideTitleSettings,
    QuizInfo,
  },
  mixins: [UndoRedoMixin, UpdateTitleSlideMixin],
  data() {
    return {
      isModalDeleteScalesStatementVisible: false,
      deleteSlideOptionIndex: null,
      optionLabel: 'Options',
      optionTooltip: '',
      optionPlaceHolder: 'Option',
      descIsOpen: false,
      showQuizInfoTop: true,
      isSortingSlideOptions: false,
      key: null,
    }
  },
  computed: {
    ...mapGetters(['isPresenting']),
    ...mapState({
      slideActive: (state) => state.slideActive,
      currentUser: (state) => state.currentUser,
      presentation: (state) => state.presentation,
    }),
    notAllowedDeleteOptions() {
      if (this.slideActive.type === 'multipleChoice'
        || this.slideActive.type === 'pickAnswer'
        || this.slideActive.type === 'imageChoice') {
        return this.slideActive.SlideOptions.length === 2
      }
      if (this.slideActive.type === 'scale') {
        return this.slideActive.SlideOptions.length === 1
      }
      return false
    },
    isSlideTitleSettingVisible() {
      const { type } = this.$store.state.slideActive
      return type === 'scale' ||
        type === 'multipleChoice' ||
        type === 'openEnded' ||
        type === 'bulletPoints' ||
        type === 'textSlide' ||
        type === 'voiceQA' ||
        type === 'wordCloud' ||
        type === 'pickAnswer' ||
        type === 'leaderboard' ||
        type === 'imageChoice' ||
        type === 'question' ||
        type === 'ideas'
    },
    isShowQuizInfo() {
      const { type } = this.$store.state.slideActive
      return this.showQuizInfoTop && (type === 'pickAnswer' || type === 'leaderboard')
    },
    isContentSlide() {
      const { type } = this.$store.state.slideActive
      return type === 'textSlide' || type === 'bulletPoints'
    },
    isTypeHasAdditionalFields() {
      const slideTypes = ['openEnded', 'ideas']
      return slideTypes.includes(this.slideActive.type)
    },
    otherSettingsVisible() {
      const slideTypes = ['scale', 'imageChoice', 'multipleChoice', 'openEnded', 'bulletPoints',
        'wordCloud', 'pickAnswer', 'leaderboard', 'question', 'ideas']
      return slideTypes.includes(this.slideActive.type)
    },
    isEURegion() {
      return Config.region === constants.euRegion
    },
    isSlideQuiz() {
      return this.slideActive.type === 'pickAnswer'
    },
    contentModalDeleteScalesStatement() {
      return 'Deleting this statement will erase all audience responses on this slide.'
    },
  },
  watch: {
    '$store.state.presentation.fontFamily': function () {
      const el = this.$refs['form-check-hide-results']
      if (!el) return
      if (
        this.$store.state.presentation.fontFamily ==
        "'Source Code Pro', 'Courier New', Courier, monospace"
      ) {
        el.classList.add('form-check-font-scpro')
      } else {
        el.classList.remove('form-check-font-scpro')
      }
    },
  },
  mounted() {
    this.registerHistory()
    const slideType = this.slideActive.type
    if (slideType === 'multipleChoice' || slideType === 'imageChoice') {
      this.optionLabel = 'Options'
      this.optionTooltip = 'Enter the options you want your audience to vote on (max 30)'
    } else if (slideType === 'bulletPoints') {
      this.optionLabel = 'Bullet points'
      this.optionTooltip = 'Enter your bullet points (up to 15)'
      this.optionPlaceHolder = 'Bullet'
    } else if (slideType === 'voiceQA') {
      this.optionLabel = 'Participant info'
    } else if (slideType === 'pickAnswer') {
      this.optionTooltip = 'Write the answer options you want players to choose from.'
      this.optionLabel = 'Options'
      this.pickmoreTooltip = 'If this is unselected, players can get full points by picking just one correct answer'

      if (this.slideActive.slideType === 'matchPairs') {
        this.optionTooltip = 'Enter the options you want your audience to choose from (max 4)'
        this.optionLabel = 'Pairs'
      }
      if (this.slideActive.slideType === 'correctOrder') {
        this.optionLabel = 'Statements'
        this.optionTooltip = 'Enter your statements. They will be placed in random order on the slide.'
      }
    } else if (slideType === 'scale') {
      this.optionLabel = 'Statements'
      this.optionTooltip = 'Enter the statements for your audience to rate'
      this.optionPlaceHolder = 'Statement'
    }

    if (this.slideActive.titleDesc) {
      if (
        slideType === 'multipleChoice' ||
        slideType === 'openEnded' ||
        slideType === 'wordCloud' ||
        slideType === 'imageChoice' ||
        slideType === 'question' ||
        slideType === 'scale' ||
        slideType === 'pickAnswer'
      ) {
        this.descIsOpen = true
      }
    }
    const showQuizInfoTop = cookie.getValue('showQuizInfoTop')
    if (!showQuizInfoTop) {
      cookie.setValue('showQuizInfoTop', new Date().getTime().toString())
    } else if (
      new Date().getTime() - parseInt(showQuizInfoTop, 10) >
      14 * 24 * 60 * 60 * 1000
    ) {
      this.showQuizInfoTop = false
    }

    const el = this.$refs['form-check-hide-results']
    if (!el) return
    if (
      this.$store.state.presentation.fontFamily ==
      "'Source Code Pro', 'Courier New', Courier, monospace"
    ) {
      el.classList.add('form-check-font-scpro')
    } else {
      el.classList.remove('form-check-font-scpro')
    }
  },

  methods: {
    ...mapActions(['updateSlideActiveAction', 'setSlideActiveAction', 'setSyncLoadingAction']),
    ...mapGetters(['getSlideActive', 'getSlideOptionsActive']),

    backupAddOptionFromTab() {
      const oldOptions = JSON.parse(JSON.stringify(this.getSlideOptionsActive()))
      oldOptions.pop()
      const newSlideOptions = JSON.parse(JSON.stringify(oldOptions))
      newSlideOptions.push({ index: oldOptions.length + 1 })
      this.addActionToHistory({
        type: 'AddOption',
        data: oldOptions,
        newData: newSlideOptions,
        slideActiveId: this.slideActive.id,
      })
    },

    handleCloseModalDeleteScalesStatement() {
      this.isModalDeleteScalesStatementVisible = false
      Utils.gaTrackEvent(
        gaCategories.PRESENTATION_EDITOR,
        'Right column > Content Tab > Confirm remove statement > Cancel',
      )
    },

    backupSortOption(newEvent) {
      const eventBackup = {
        moved: {
          element: { id: newEvent.moved.element.id },
          newIndex: newEvent.moved.oldIndex,
          oldIndex: newEvent.moved.newIndex,
        },
      }
      this.addActionToHistory({
        type: 'SortOption',
        data: eventBackup,
        newData: newEvent,
        slideActiveId: this.slideActive.id,
      })
    },

    async restoreSortOption(data) {
      const { newIndex, oldIndex } = data.moved
      await this.swapSlideOptions(newIndex, oldIndex)
      await this.sortOption(data, false)
      this.key = (new Date()).getTime()
    },

    async swapSlideOptions(newIndex, oldIndex) {
      const slideOptions = this.getSlideOptionsActive()

      const temp = slideOptions[oldIndex]
      slideOptions.splice(oldIndex, 1)
      slideOptions.splice(newIndex, 0, temp)

      await this.updateSlideActiveAction({
        SlideOptions: JSON.parse(JSON.stringify(slideOptions)),
      })
    },

    async sortOption(event, isBackup = true) {
      if (isBackup) {
        this.backupSortOption(event)
      }
      const slideOptions = this.getSlideOptionsActive()

      if (slideOptions.length < 2 || !event || !event.moved) return

      const { newIndex, oldIndex, element: movedSlideOption } = event.moved

      if (newIndex === oldIndex) return
      if (this.isSortingSlideOptions) return

      this.isSortingSlideOptions = true
      let newOrder = null
      if (newIndex === slideOptions.length - 1) {
        newOrder = slideOptions[slideOptions.length - 2].order + 1
      } else if (newIndex === 0) {
        newOrder = slideOptions[1].order / 2
      } else {
        newOrder = (slideOptions[newIndex + 1].order + slideOptions[newIndex - 1].order) / 2
      }

      const newSlideOptions = slideOptions.map((option) => {
        if (option.id === movedSlideOption.id) {
          return { ...option, order: newOrder }
        }

        return option
      })

      this.updateSlideActiveAction({
        SlideOptions: newSlideOptions,
      })

      if (!movedSlideOption.id) {
        this.isSortingSlideOptions = false
      }

      if (movedSlideOption.id) {
        this.$store.dispatch('setSyncPresentation', 1)
        try {
          await SlideOptionApi.patchSlideOptionById(movedSlideOption.id, {
            order: newOrder,
            presentationId: this.$store.state.presentation.id,
            uniqueAccessCode: this.$store.state.presentation.uniqueAccessCode,
            socketId: Socket.getSocketId(),
          })

          this.$store.dispatch('setSyncPresentation', 2)
          this.isSortingSlideOptions = false
        } catch (error) {
          this.$store.dispatch('setSyncPresentation', 3)
          this.isSortingSlideOptions = false
          throw error
        }
      }

      EventBus.$emit('changeSlideOption')
    },

    backupUpdateOption(oldData, newData, key) {
      this.addActionToHistory({
        type: 'InputTitleOption',
        data: oldData,
        newData,
        slideActiveId: this.slideActive.id,
      }, key)
    },

    async restoreInputTitleOption(data) {
      const dataBackup = {
        ...data,
        value: data.value ? data.value : '',
      }
      if (dataBackup.id) {
        const oldSlideOptions = this.getSlideOptionsActive()
        const findItem = oldSlideOptions.find((item) => item.id === dataBackup.id)
        if (!findItem) {
          await this.callAPIEventCreate(dataBackup)
        }
      }
      await this.updateTitleOption(dataBackup, false)
      const SlideOptions = this.getSlideOptionsActive()
      this.updateSlideActiveAction({
        SlideOptions: [],
      })
      this.key = (new Date()).getTime()
      await new Promise((resolve) => {
        this.$nextTick(() => {
          this.updateSlideActiveAction({
            SlideOptions,
          })
          this.key = (new Date()).getTime()
          resolve()
        })
      })
    },

    getOptionFromEventData(eventData) {
      const slideOptions = this.getSlideOptionsActive()
      if (eventData.id) {
        return slideOptions.find((item) => item.id === eventData.id)
      }
      return slideOptions[eventData.index]
    },

    async updateTitleOption(data, isBackup = true) {
      const key = (new Date()).getTime()
      this.lockHistory(key)
      let currentTitle = ''
      const option = this.getOptionFromEventData(data)
      if (option) {
        currentTitle = option.title
      }
      const id = await this.updateOption(data)
      if (typeof id !== 'number') {
        this.unlockHistory(key, false)
        return false
      }
      if (!isBackup || currentTitle === data.value) {
        this.unlockHistory(key, false)
        return null
      }
      const oldData = {
        ...data,
        value: currentTitle,
        id,
      }
      const newData = {
        ...data,
        id: oldData.id,
      }
      if (!data.id && currentTitle === '') {
        newData.id = null
      }
      this.backupUpdateOption(oldData, newData, key)
      this.unlockHistory(key)
    },

    async updateOption(data, cb) {
      this.$store.dispatch('setSyncPresentation', 1)
      let optionId = data.id
      if (!data.id) {
        const { SlideOptions: slideOptions } = this.slideActive

        const highestOrder = slideOptions.reduce((accumulator, item) => {
          return item.order > accumulator ? item.order : accumulator
        }, 1)

        if (slideOptions[data.index].isLoading) return
        slideOptions[data.index].isLoading = true
        const payload = {
          title: data.value,
          order: slideOptions[data.index].order || highestOrder + 1,
          slideId: this.slideActive.id,
          presentationId: this.$store.state.presentation.id,
          accessCode: this.$store.state.presentation.uniqueAccessCode,
          correct: data.correct,
          socketId: Socket.getSocketId(),
        }
        try {
          if (data.index === undefined) return

          if (this.slideActive.SlideOptions[data.index]) {
            slideOptions[data.index].title = payload.title
            slideOptions[data.index].order = payload.order
          }

          this.updateSlideActiveAction({
            SlideOptions: slideOptions,
          })

          const slideId = this.slideActive.id

          const res = await this.$http.post(Config.api.createSlideOption, payload)
          optionId = res.body.id

          if (slideOptions[data.index]) {
            slideOptions[data.index].id = res.body.id
          }
          if (slideId === this.slideActive.id) {
            this.updateSlideActiveAction({
              SlideOptions: slideOptions,
            })
          } else {
            const index = this.$store.state.presentation.slides.findIndex((item) => {
              return item.id === this.slideActive.id
            })
            if (index !== -1) {
              this.$store.state.presentation.slides[index].SlideOptions = slideOptions
            }
          }

          this.$store.dispatch('setSyncPresentation', 2)
          if (cb) {
            cb(res.body)
          }
          Utils.gaTrackEvent('Presentation Editor', 'Slide option > Edit > Succeeded')
          EventBus.$emit('changeSlideOption')
        } catch {
          this.$store.dispatch('setSyncPresentation', 3)
        }
      } else {
        const { SlideOptions } = this.$store.getters.getSlideActive
        if (SlideOptions.length - 1 < data.index) {
          return
        }
        SlideOptions[data.index].title =
            data.value

        // Redo Add-options sẽ không có id nên phải set lại id
        if (!SlideOptions[data.index].id) {
          SlideOptions[data.index].id = data.id
        }
        this.updateSlideActiveAction({
          SlideOptions,
        })
        this._updateOption(
          {
            title: data.value,
            deleted: false,
            presentationId: this.$store.state.presentation.id,
            accessCode: this.$store.state.presentation.uniqueAccessCode,
          },
          data.id,
        )
        let typeGa = this.slideActive.type
        if (this.slideActive.type === 'multipleChoice' || this.slideActive.type === 'imageChoice') {
          typeGa = 'Poll'
        }
        Utils.gaTrackEvent(
          gaCategories.PRESENTATION_EDITOR,
          'Side right > Change slide option title',
          `Slide type: ${typeGa}`,
        )
      }
      return optionId
    },

    _updateOption(params, id, cb) {
      params.socketId = Socket.getSocketId()
      params.presenting = this.$store.getters.isPresenting
      params.presentationId = this.$store.state.presentation.id
      const SlideOptions = this.getSlideOptionsActive()
      this.updateSlideActiveAction({
        SlideOptions,
      })
      this.$http.put(Config.api.updateSlideOption + id, params).then(
        () => {
          this.$store.dispatch('setSyncPresentation', 2)
          if (cb) {
            cb()
          }
          EventBus.$emit('changeSlideOption')
        },
        () => {
          this.$store.dispatch('setSyncPresentation', 3)
        },
      )
    },

    updateSlide(data, isBackup = true) {
      if (isBackup) {
        this.backupUpdateSlide(data)
      }
      const payload = {}
      if (data.subheading) {
        payload.subheading = data.subheading
      } else if (data.subheading === '') {
        payload.subheading = ' '
      }

      this.$store.dispatch('setSyncPresentation', 1)
      payload.presentationId = this.$store.state.presentation.id
      payload.accessCode = this.$store.state.presentation.uniqueAccessCode
      payload.socketId = Socket.getSocketId()
      payload.presenting = this.$store.getters.isPresenting || this.$store.getters.isBackstage

      this.updateSlideActiveAction({
        ...payload,
      })

      this.$http
        .put(Config.api.updateSlide + this.slideActive.id, payload)
        .then(
          () => {
            this.$store.dispatch('setSyncPresentation', 2)
          },
          () => {
            this.$store.dispatch('setSyncPresentation', 3)
          },
        )
      if (payload.subheading) {
        Utils.gaTrackEvent(
          'Slide',
          'Edit text slide',
          'Done editing subheading',
        )
      }
    },

    // Toggle sticker and GA track
    updateSettingSlide(type, cb) {
      const params = {
        accessCode: this.$store.state.presentation.uniqueAccessCode,
        socketId: Socket.getSocketId(),
      }
      if (type == 1) {
        this.$store.state.slideActive.multipleChoice = !this.$store.state.slideActive.multipleChoice
        params.multipleChoice = this.$store.state.slideActive.multipleChoice
        if (this.slideActive.type === 'pickAnswer') {
          params.limitChoice = this.slideActive.SlideOptions.length
        }
      } else if (type == 2) {
        params.limitChoice = this.slideActive.limitChoice
      } else if (type == 4) {
        params.addCorrectOption = this.slideActive.addCorrectOption
      } else if (type == 9) {
        this.slideActive.entriesPerParticipant = parseInt(
          this.slideActive.entriesPerParticipant,
          10,
        )
        if (this.slideActive.entriesPerParticipant < 1) {
          this.slideActive.entriesPerParticipant = 1
        } else if (this.slideActive.entriesPerParticipant > 10) {
          this.slideActive.entriesPerParticipant = 10
        }
        if (!this.slideActive.entriesPerParticipant) {
          params.entriesPerParticipant = 1
          return
        }
        params.entriesPerParticipant = this.slideActive.entriesPerParticipant
      } else if (type == 13) {
        params.isCorrectGetPoint = this.slideActive.isCorrectGetPoint
      } else if (type === 14 || type === 15 || type === 16) {
        params.scale = this.slideActive.scale
      }

      this.setSlideActiveAction(this.getSlideActive())
      params.presenting = this.$store.getters.isPresenting
      this.setSyncLoadingAction(1)
      this._updateSlide(params, type, cb)
    },

    async _updateSlide(params, type, cb) {
      try {
        await SlideApi.updateSlideById(this.slideActive.id, params)
        const index = this.presentation.slides.findIndex(
          (item) => {
            return item.id == this.slideActive.id
          },
        )
        if (index == -1) return
        if (type == 1) {
          this.presentation.slides[
            index
          ].multipleChoice = this.slideActive.multipleChoice
          Utils.gaTrackEvent(
            gaCategories.PRESENTATION_EDITOR,
            'Side right > Allow picking more than one option',
            `Allow picking more than one option: ${this.slideActive.multipleChoice}`,
          )
        } else if (type == 2) {
          this._handleAfterUpdateSettingLimitChoice(index)
        } else if (type == 4) {
          this.presentation.slides[
            index
          ].addCorrectOption = this.slideActive.addCorrectOption
          Utils.gaTrackEvent(
            'Slide',
            'Edit setting',
            'Presenter edit setting enable add correct answer',
            this.slideActive.addCorrectOption,
          )
        } else if (type == 9) {
          this.presentation.slides[
            index
          ].entriesPerParticipant = this.slideActive.entriesPerParticipant
          Utils.gaTrackEvent(
            'Slide',
            'Edit setting',
            'Presenter edit setting entriesPerParticipant',
          )
        } else if (type == 13) {
          this.presentation.slides[
            index
          ].isCorrectGetPoint = this.slideActive.isCorrectGetPoint
          if (this.slideActive.isCorrectGetPoint == 'true') {
            Utils.gaTrackEvent(
              'Slide',
              'Edit setting',
              'Presenter edit the more the better',
            )
          } else {
            Utils.gaTrackEvent(
              'Slide',
              'Edit setting',
              'Presenter edit must not miss any',
            )
          }
        }
        this.setSyncLoadingAction(2)
        if (cb) cb()
      } catch (error) {
        this.setSyncLoadingAction(3)
        if (cb) cb(error)
      }
    },

    backupAddOption(slideOptions) {
      const newSlideOptions = JSON.parse(JSON.stringify(slideOptions))
      newSlideOptions.push({ index: this.getSlideOptionsActive().length + 1 })
      this.addActionToHistory({
        type: 'AddOption',
        data: JSON.parse(JSON.stringify(slideOptions)),
        newData: JSON.parse(JSON.stringify(newSlideOptions)),
        slideActiveId: this.slideActive.id,
      })
    },

    async undoAddOption() {
      const SlideOptions = this.getSlideOptionsActive()
      this.deleteOption(SlideOptions[SlideOptions.length - 1], SlideOptions.length - 1, false)
      this.key = (new Date()).getTime()
    },

    async redoAddOption() {
      this.addOption(false)
      this.key = (new Date()).getTime()
    },

    addOption(isBackup = true) {
      const { type } = this.slideActive
      const SlideOptions = this.getSlideOptionsActive()
      const optionsLength = SlideOptions.length
      if (optionsLength > 29) return
      if ((type === 'multipleChoice' || type === 'imageChoice') && optionsLength > 29) return
      if (type === 'bulletPoints' && optionsLength > 14) return
      if (type === 'scale' && optionsLength > 7) return

      if (isBackup) {
        this.backupAddOption(JSON.parse(JSON.stringify(SlideOptions)))
      }

      SlideOptions.push({
        index: this.slideActive.SlideOptions.length + 1,
      })
      this.updateSlideActiveAction({
        SlideOptions,
      })
      Utils.gaTrackEvent(
        gaCategories.PRESENTATION_EDITOR,
        'Side right > Add slide option',
      )
    },

    backupDeleteOption(dataHistory) {
      const { SlideOptions } = this.slideActive
      const dataUndo = {
        item: dataHistory.item,
        index: dataHistory.index,
        slideOptions: SlideOptions,
      }
      this.addActionToHistory(JSON.parse(JSON.stringify({
        type: 'DeleteOption',
        data: dataUndo,
        newData: dataHistory,
        slideActiveId: this.slideActive.id,
      })))
    },

    async undoDeleteOption({ item, slideOptions }) {
      await this.callAPIUpdateFieldDeletedSlideOption(item.id, false)

      this.updateSlideActiveAction({
        SlideOptions: slideOptions,
      })
      await this.callAPIEventCreate(item)
      this.key = (new Date()).getTime()
    },

    async callAPIEventCreate(data) {
      await this.$http
        .post(Config.api.updateEventSlideOption, {
          action: 'create',
          data,
          presentationId: this.$store.state.presentation.id,
          accessCode: this.$store.state.presentation.uniqueAccessCode,
          socketId: Socket.getSocketId(),
          presenting: this.$store.getters.isPresenting,
        })
    },

    async callAPIUpdateFieldDeletedSlideOption(slideOptionId, isDelete) {
      await this.$http
        .put(Config.api.updateSlideOption + slideOptionId, {
          deleted: isDelete,
          presentationId: this.$store.state.presentation.id,
          accessCode: this.$store.state.presentation.uniqueAccessCode,
          socketId: Socket.getSocketId(),
          presenting: this.$store.getters.isPresenting,
        })
    },

    async redoDeleteOption({ item, index }) {
      await this.deleteOption(item, index, false)
      this.key = (new Date()).getTime()
    },

    deleteOption(item, index, isBackup = true) {
      if (this.notAllowedDeleteOptions) return
      if (isBackup) {
        this.backupDeleteOption({ item, index })
      }
      if (this.slideActive.type === 'scale' && this.slideActive.hasScaleQuestionAnswer) {
        if (!item.id) {
          const { SlideOptions } = this.slideActive
          SlideOptions.splice(index, 1)
          this.updateSlideActiveAction({
            SlideOptions,
          })
          return
        }
        this.deleteSlideOptionIndex = index
        this.isModalDeleteScalesStatementVisible = true
        return
      }
      this._handleDeleteOption(item, index)
      if (this.slideActive.type === 'scale') {
        EventBus.$emit('changeSlideOption')
      }
    },

    handleDeleteScalesStatement(item, index, cb) {
      const SlideOptions = this.getSlideOptionsActive()

      SlideOptions.splice(index, 1)
      this.updateSlideActiveAction({
        SlideOptions,
      })

      if (!item.id) return

      this.setSyncLoadingAction(1)
      this.$http
        .put(Config.api.updateSlideOption + item.id, {
          deleted: true,
          presentationId: this.$store.state.presentation.id,
          accessCode: this.$store.state.presentation.uniqueAccessCode,
          socketId: Socket.getSocketId(),
          presenting: this.$store.getters.isPresenting,
        })
        .then(
          () => {
            this.setSyncLoadingAction(2)
            Utils.gaTrackEvent(
              gaCategories.PRESENTATION_EDITOR,
              'Side right > Delete slide option',
            )
            if (cb) cb()
          },
          () => {
            this.setSyncLoadingAction(3)
          },
        )

      if (!item.count) item.count = 0
      if (!item.count) return
      let multipleCountAnswer = 0
      if (!this.slideActive.multipleCountAnswer) multipleCountAnswer = 0
      multipleCountAnswer = this.slideActive.multipleCountAnswer - item.count

      this.updateSlideActiveAction({
        multipleCountAnswer,
      })
    },

    async _handleDeleteOption(item, index) {
      try {
        const SlideOptions = this.getSlideOptionsActive()

        SlideOptions.splice(index, 1)
        this.updateSlideActiveAction({
          SlideOptions,
        })

        if (!item.id) return
        this.setSyncLoadingAction(1)
        const payload = {
          deleted: true,
          presentationId: this.presentation.id,
          accessCode: this.presentation.uniqueAccessCode,
          socketId: Socket.getSocketId(),
          presenting: this.isPresenting,
        }
        await SlideOptionApi.updateSlideOption(item.id, payload)

        this.setSyncLoadingAction(2)
        Utils.gaTrackEvent(
          gaCategories.PRESENTATION_EDITOR,
          'Side right > Delete slide option',
        )
        if (
          this.slideActive.limitChoice >
        this.slideActive.SlideOptions.length
        ) {
          this.updateSlideActiveAction({
            limitChoice: this.slideActive.SlideOptions.length,
          })
          this.updateSettingSlide(2)
        }
        if (!item.count) item.count = 0
        if (!item.count) return
        let multipleCountAnswer = 0
        if (!this.slideActive.multipleCountAnswer) multipleCountAnswer = 0
        multipleCountAnswer = this.slideActive.multipleCountAnswer - item.count
        this.updateSlideActiveAction({
          multipleCountAnswer,
        })
        if (!this.slideActive.SlideOptions.length || multipleCountAnswer < 1) {
          PresentationUtils.checkAndUpdatePresentationHasResults()
        }
      } catch (error) {
        this.setSyncLoadingAction(3)
      }
    },

    _handleAfterUpdateSettingLimitChoice(index) {
      this.$store.state.presentation.slides[
        index
      ].limitChoice = this.slideActive.limitChoice
      let slideType = this.slideActive.type
      if (slideType === 'ideas') {
        slideType = 'brainstorm'
      }
      Utils.gaTrackEvent(
        gaCategories.PRESENTATION_EDITOR,
        'Side right > Edit limit choice',
        `Slide type: ${slideType}, Number of choice: ${this.slideActive.limitChoice}`,
      )
    },

  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variable.scss";
.input-group {
  user-select: none;
}
.form-check-inline::v-deep {
  &.form-check-font-scpro {
    margin-bottom: 40px;
  }
  @media (max-width: 320px) {
    &.hide-result-form {
      margin-right: 0;
      .button-show-all {
        margin-left: -2.5px;
      }
    }
  }
}
.input-option {
  & ::v-deep .input-style {
    width: min-content;
  }
}
</style>
